import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import "../../styles/depots/depots.scss";
import { apiHost } from "../../api/apiClient";
import axios from "axios";
import DepotMap from "../maps/depotMap";
import renderHTML from "react-render-html";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { searchSuggestionAPI, GeoCodeAPI } from "../../utils/mapapi";

class EditDepot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      customerId: "",
      customerName: "",
      name: "",
      timeZoneArr: [],
      timeZoneName: "",
      description: "",
      error: false,
      timeZoneId: "",
      mapOverlay: "",
      id: "",
      suggestions: [],
      suggestionVisibility: false,
      searchText: "",
      lat: "",
      lng: "",
      customerError: false,
      nameError: false,
      descriptionError: false,
      timeZoneError: false,
      mapOverlayError: false,
    };

    this.circleLat = "";
    this.circleLng = "";
    this.circleRad = "";

    this.rectLat1 = "";
    this.rectLat2 = "";
    this.rectLng1 = "";
    this.rectLng2 = "";

    this.polygonArr = [];
    this.type = "";
  }

  async componentDidMount() {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Depots/SelectDepot/${this.props.match.params.id}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setData(response.data);
      }
      console.log("response ", response.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    this.getCustomers();
    this.getTimeZone();
  }

  setData = (data) => {
    const {
      name,
      description,
      customerName,
      customerId,
      timeZonesId,
      timeZoneCity,
      mapOverlay,
      id,
    } = data;

    this.setGraph(JSON.parse(mapOverlay));
    this.setState({
      name,
      description,
      customerName,
      timeZoneId: timeZonesId,
      timeZoneCity,
      timeZoneName: timeZoneCity,
      customerId,
      mapOverlay,
      id,
    });
  };

  setGraph = (data) => {
    this.type = data.type;

    switch (data.type) {
      case "circle":
        this.circleLat = data.lat;
        this.circleLng = data.lng;
        this.circleRad = data.rad;
        break;
      case "polygon":
        this.polygonArr = this.handleArrRecreation(data.arr || []);
        break;
      case "rectangle":
        this.rectLat1 = data.lat1;
        this.rectLat2 = data.lat2;
        this.rectLng1 = data.lng1;
        this.rectLng2 = data.lng2;
        break;
      default: break;
    }
  };

  getCustomers = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllCustomers`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ customers: response.data });
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  getTimeZone = async () => {
    this.props.setLoadingPageAction(true);

    try {
      const response = await axios.get(
        `${apiHost}/api/Customer/GetAllTimeZone`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.status == "200") {
        this.setState({ timeZoneArr: response.data });
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleTimeZone = (evt) => {
    if (evt.target.value == "") {
      this.setState({ timeZoneError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.state.timeZoneArr.forEach((time) => {
      if (time.timeZoneCity == evt.target.value) {
        this.setState({
          timeZoneId: time.timeZonesId,
          timeZoneName: time.timeZoneCity,
        });
      }
    });
  };

  handleName = (evt) => {
    if (evt.target.value == "") {
      this.setState({ nameError: true });
    } else {
      this.setState({ nameError: false });
    }
    this.setState({ name: evt.target.value });
  };

  handleDescription = (evt) => {
    this.setState({ description: evt.target.value });
  };

  handleArrCreation = (data) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i] == 0) data.splice(i, 1);
    }
    var requiredArr = [];
    for (let i = 0; i < data.length; i += 2) {
      const coordinateObj = {
        lat: data[i],
        lng: data[i + 1],
      };
      requiredArr.push(coordinateObj);
    }

    return requiredArr;
  };

  handleArrRecreation = (data) => {
    var requiredArr = [];
    data.forEach((element) => {
      requiredArr.push(element.lat);
      requiredArr.push(element.lng);
      requiredArr.push(0);
    });

    return requiredArr;
  };

  handleCircleCreate = (data) => {
    this.circleLat = data.lat;
    this.circleLng = data.lng;
    this.circleRad = data.rad;
    this.type = "circle";
  };

  handlePolygonCreate = (data) => {
    this.polygonArr = data;
    this.type = "polygon";
  };

  handleRectangleCreate = (data) => {
    this.type = "rectangle";
    this.rectLat1 = data.lat1;
    this.rectLat2 = data.lat2;
    this.rectLng1 = data.lng1;
    this.rectLng2 = data.lng2;
  };

  handleCreate = async () => {
    const { name, description, customerId, timeZoneId, id } = this.state;
    const obb = {
      name: name,
      description: description,
      customerId: customerId,
      timeZonesId: timeZoneId,
      id: id,
    };

    var mapOverlayObj;

    switch (this.type) {
      case "circle":
        mapOverlayObj = {};
        mapOverlayObj.type = this.type;
        mapOverlayObj.lat = this.circleLat;
        mapOverlayObj.lng = this.circleLng;
        mapOverlayObj.rad = this.circleRad;

        obb.MapOverlay = JSON.stringify(mapOverlayObj);

        break;
      case "polygon":
        mapOverlayObj = {};
        mapOverlayObj.type = this.type;
        mapOverlayObj.arr = this.handleArrCreation(this.polygonArr);
        obb.MapOverlay = JSON.stringify(mapOverlayObj);

        break;
      case "rectangle":
        mapOverlayObj = {};
        mapOverlayObj.type = this.type;
        mapOverlayObj.north = this.rectLat1;
        mapOverlayObj.south = this.rectLat2;
        mapOverlayObj.west = this.rectLng1;
        mapOverlayObj.east = this.rectLng2;

        obb.MapOverlay = JSON.stringify(mapOverlayObj);

        break;
      default: break;
    }

    if (name && customerId && timeZoneId) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(`${apiHost}/api/Depots/Update`, obb, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        if (response.status == "200") {
          this.props.history.goBack();
        }
        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
        this.setState({ error_authorisation: true });
      }
    } else {
      this.setState({ error: true });
      setTimeout(() => {
        this.setState({ error: false });
      }, 3000);
    }
  };

  validationCheck = (obj) => {
    if (!this.state.name) {
      this.setState({ nameError: true });
    }
    if (!this.state.customerId) {
      this.setState({ customerError: true });
    }
    if (!this.state.timeZoneId) {
      this.setState({ timeZoneError: true });
    }
    if (!obj) {
      this.setState({ mapOverlayError: true });
    }
  };

  handleBack = () => {
    //this.props.history.push("/depots");
    this.props.history.goBack();
  };

  // Map search and suggestions starts here
  handleLocationChange = (searchText) => {
    this.setState({ searchText });
    this.handleSearchSuggestion(searchText);
  };

    handleSearch = async () => {
        try {
            console.log("searec1", this.state.searchText);
            const { lat, lng } = await GeoCodeAPI(this.state.searchText);
            if (lat !== 0 && lng !== 0) {
                this.setState({
                    lat: lat,
                    lng: lng,
                });
            } else {
                this.setState({ errorSearch: true });
                setTimeout(() => {
                    this.setState({ errorSearch: false });
                }, 1000);
            }
        } catch (e) {
            console.log(`😱 Axios request failed: ${e}`);
        }
    };

  handleSearchSuggestion = async (query) => {
    if (query != "") {
      this.setState({ suggestionVisibility: false });
    }
    this.setState({ suggestionVisibility: true });
      try {
          const items = await searchSuggestionAPI(query);
          this.setState({ suggestions: items });
      } catch (e) {
          console.log(e);
      }
  };
  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      console.log("enter press here! ", event.target.value);
      this.handleSuggestionClick(event.target.value);
    }
  };
    handleSuggestionClick = async (place) => {
        var nwlocation = place.replace("<b>", "");
        var location = nwlocation.replace("</b>", "");

        this.setState({ searchText: location, suggestionVisibility: false });
        try {
            console.log("searecyy", location);
            const { lat, lng } = await GeoCodeAPI(location);
            if (lat !== 0 && lng !== 0) {
                this.setState({
                    lat: lat,
                    lng: lng,
                });
            } else {
                this.setState({ errorSearch: true });
                setTimeout(() => {
                    this.setState({ errorSearch: false });
                }, 1000);
            }
        } catch (e) {
            console.log(`😱 Axios request failed: ${e}`);
        }
    };
  // Map search and suggestions ends here

  render() {
    const {
      timeZoneArr,
      customerName,
      timeZoneName,
      name,
      description,
      mapOverlay,
      lat,
      lng,
      customerError,
      nameError,
      timeZoneError,
      mapOverlayError,
    } = this.state;

    console.log("overlay point", mapOverlay);
    console.log("timeZoneName", timeZoneName);

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Edit Depot </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>Edit Depot</h2>
              <hr />
              <div className="formGroup">
                <Form>
                  <Form.Group as={Row} controlId="formPlainTimeZone">
                    <Form.Label column sm="2">
                      Customer
                    </Form.Label>
                    <Col sm="4">
                      <p className="detailsValue">{customerName}</p>
                      <p
                        style={
                          customerError
                            ? { color: "#a94442", fontSize: "14px" }
                            : { display: "none" }
                        }
                      >
                        The Customer field is required.
                      </p>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="formPlaintextName">
                    <Form.Label column sm="2">
                      Name
                    </Form.Label>
                    <Col sm="4">
                      <Form.Control
                        onChange={this.handleName}
                        type="plaintext"
                        placeholder=""
                        value={name}
                      />
                      <p
                        style={
                          nameError
                            ? { color: "#a94442", fontSize: "14px" }
                            : { display: "none" }
                        }
                      >
                        The Name field is required.
                      </p>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="formPlaintextName">
                    <Form.Label column sm="2">
                      Description
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        as="textarea"
                        rows="3"
                        onChange={this.handleDescription}
                        value={description}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="formPlainTimeZone">
                    <Form.Label column sm="2">
                      TimeZone
                    </Form.Label>
                    <Col sm="4">
                      <Form.Control
                        as="select"
                        onChange={this.handleTimeZone}
                        value={timeZoneName}
                      >
                        <option value="default">Select TimeZone</option>
                        {timeZoneArr.map((timezone, index) => (
                          <option key={index}>{timezone.timeZoneCity}</option>
                        ))}
                      </Form.Control>
                      <p
                        style={
                          timeZoneError
                            ? { color: "#a94442", fontSize: "14px" }
                            : { display: "none" }
                        }
                      >
                        The TimeZone field is required.
                      </p>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="formPlainTimeZone">
                    <Form.Label column sm="2">
                      Overlay
                    </Form.Label>
                    <Col sm="10">
                      <div className="containerMapDepot">
                        <DepotMap
                          onCircleCreate={this.handleCircleCreate}
                          onPolygonCreate={this.handlePolygonCreate}
                          onRectangleCreate={this.handleRectangleCreate}
                          mapOverlay={mapOverlay}
                          lat={lat}
                          lng={lng}
                        />
                        <div className="overlaySearch">
                          <Col sm="12" className="inputSuggestions">
                            <Form.Control
                              value={this.state.searchText}
                              onChange={(e) =>
                                this.handleLocationChange(e.target.value)
                              }
                              onKeyPress={(e) => this.handleKeyPress(e)}
                              autocomplete="off"
                              type="plaintext"
                              placeholder="Search location"
                            />
                            {this.state.suggestionVisibility && (
                              <ul>
                                {this.state.suggestions &&
                                  this.state.suggestions.map((item, index) => {
                                    return (
                                      <li
                                            key={item.address.label}
                                        onClick={() =>
                                            this.handleSuggestionClick(item.address.label)
                                        }
                                      >
                                            {renderHTML(item.address.label)}
                                      </li>
                                    );
                                  })}
                              </ul>
                            )}
                            <p
                              style={
                                mapOverlayError
                                  ? { color: "#a94442", fontSize: "14px" }
                                  : { display: "none" }
                              }
                            >
                              The Map field is required.
                            </p>
                          </Col>
                        </div>
                      </div>
                    </Col>
                  </Form.Group>
                  <Row>
                    <Col sm="2"></Col>
                    <Col sm="9">
                      <Button variant="light" onClick={this.handleBack}>
                        Back to List
                      </Button>
                      <Button variant="primary" onClick={this.handleCreate}>
                        Save
                      </Button>
                    </Col>
                  </Row>
                  {this.state.error && (
                    <Row>
                      <Col sm="2"></Col>
                      <Col sm="9">
                        <p className="error-text">
                          Please fill all the Required fields
                        </p>
                      </Col>
                    </Row>
                  )}

                </Form>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditDepot);
